import { c as _c } from "react/compiler-runtime";
import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { createRichTextOptions } from "@/lib/formatters/formatRichText";
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale";
const FeaturedText = featuredTextData => {
  const $ = _c(16);
  const lang = featuredTextData?.lang || DEFAULT_PUBLIC_LANG;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== featuredTextData.data?.featuredContent?.json || $[1] !== featuredTextData.data?.header || $[2] !== lang) {
    const richTextOptions = createRichTextOptions(lang);
    t2 = "flex flex-col md:flex-row";
    const t4 = featuredTextData?.data?.header;
    if ($[7] !== t4) {
      t3 = <div className="w-full md:w-2/5 md:pr-12"><h2 className="!text-[76px] leading-[1.05] !font-light mb-8 md:mb-0 md:leading-tight md:text-[64px] sm:text-[48px] break-normal">{t4}</h2></div>;
      $[7] = t4;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t0 = "md:pr-18 w-full text-base md:w-3/5 md:text-lg lg:pr-24 text-gray-m10 mb-8 text-base font-normal leading-8";
    t1 = documentToReactComponents(featuredTextData?.data?.featuredContent?.json, richTextOptions);
    $[0] = featuredTextData.data?.featuredContent?.json;
    $[1] = featuredTextData.data?.header;
    $[2] = lang;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[9] !== t0 || $[10] !== t1) {
    t4 = <div className={t0}>{t1}</div>;
    $[9] = t0;
    $[10] = t1;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default FeaturedText;